import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";
import { StringID } from "userful-chronos-app-common-js/dist/models/common";
import {
    REQUEST_ACTIVATE_LICENSE,
    REQUEST_GET_LICENSE,
    REQUEST_LICENSE_CU_USAGE,
    REQUEST_UPDATE_LICENSE,
    REQUEST_UPDATE_LICENSED_DISPLAYS,
    REQUEST_UPLOAD_LICENSE,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/license/license";
//
export const requestLicense = (veID: StringID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_GET_LICENSE, veID);
};

export const requestLicenseCUUsage = () => {
    getGlobalStates().eventBus.sendMsg(REQUEST_LICENSE_CU_USAGE);
};

export const requestUpdateLicense = (veID: StringID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_UPDATE_LICENSE, veID);
};

export const requestActivateLicense = (
    veID: StringID,
    displays: number,
    activationCode: string,
    gpus: number,
    cpus: number,
    engage: number,
    cu,
) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_ACTIVATE_LICENSE, {
        id: veID,
        displays,
        activationCode,
        gpus,
        cpus,
        engage,
        cu,
    });
};

export const requestUploadLicense = (veID: StringID, licenseString: string) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_UPLOAD_LICENSE, {
        id: veID,
        licenseString,
    });
};

export const requestUpdateLicensedDisplays = (veID: StringID, displays: number) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_UPDATE_LICENSED_DISPLAYS, {
        id: veID,
        displays,
    });
};
